import { ADMIN_API_BASE } from '../../callApi'
import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

export const collection = 'adminOrgEnable'

export const schema = new schemas.Entity(collection)

export const create =
  (callApi: CallApi) =>
  ({ organizationId }: { organizationId: string }) => {
    return callApi(
      `${ADMIN_API_BASE}/organizations/${organizationId}/enable`,
      schema,
      { method: 'POST' }
    )
  }
